import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=0bc87584&scoped=true&"
import script from "./ProvidersList.vue?vue&type=script&lang=js&"
export * from "./ProvidersList.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=0bc87584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc87584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc87584')) {
      api.createRecord('0bc87584', component.options)
    } else {
      api.reload('0bc87584', component.options)
    }
    module.hot.accept("./ProvidersList.vue?vue&type=template&id=0bc87584&scoped=true&", function () {
      api.rerender('0bc87584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/ProvidersList.vue"
export default component.exports